import React from "react";
import { Spin } from "antd";

const KycTileSpin = ({ spinning, children }) => (
	<Spin spinning={Boolean(spinning)} wrapperClassName="kyc-tile-spin">
		{children}
	</Spin>
);

export default KycTileSpin;
